import { fetchApi } from '@/config/axiosSetting';
import { IBodyAddSubstitutionPartParams } from '@/modules/adjusterReportModules/Insurer-information/queries/addBodySubstitutionPart/addBodySubstitutionPartQuery.type';

export const addBodySubstitutionPartQueryFunction = (
  params: IBodyAddSubstitutionPartParams,
) => {
  return fetchApi.post(
    `body/reports/${params?.id}/adjusting/substitution_parts/`,
    params?.data,
    {
      params: {
        source: params?.source,
        id: params?.id,
      },
    },
  );
};
